import Separator from "@components/CustomTypography/Separator/Separator"
import ButtonComponent from "@components/Theme/Button/Button"
import Typography, {
	Size,
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import {FAQModuleType} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React, {useRef, useState} from "react"

import styles from "./AccordionItem.module.scss"

export type AccordionItemType = {question: string; answer: string}

type Props = {
	AccordionItem: FAQModuleType
}

const AccordionItem = (props: Props) => {
	const [active, setActive] = useState<boolean>(false)

	const handleItemClick = () => {
		setActive((prevState) => {
			return !prevState
		})
	}
	const contentEl = useRef<HTMLDivElement>(null)

	return (
		<div
			className={styles.accordionRow}
			itemProp={"mainEntity"}
			itemScope
			itemType={"https://schema.org/Question"}
		>
			<ButtonComponent
				buttonType={"unstyled"}
				className={`${styles.accordionQuestion} ${
					active ? styles.active : ""
				}`}
				data-testid={"AccordionItemButton"}
				expandActive={active}
				expandUnactive={!active}
				onClick={handleItemClick}
			>
				<Typography
					as={"h5"}
					className={styles.buttonTitle}
					content={props.AccordionItem.question}
					fontWeight={600}
					itemProp={"name"}
					size={Size.S}
					variant={Variant.Title}
				/>
			</ButtonComponent>

			<div
				itemProp={"acceptedAnswer"}
				itemScope
				itemType={"https://schema.org/Answer"}
			>
				<div
					ref={contentEl}
					className={`${styles.accordionAnswert} ${
						styles.insideText
					} ${
						active ? styles.listEnterActive : styles.listExitActive
					}`}
					data-testid={"AccordionItemBody"}
					style={
						active
							? {height: contentEl.current?.scrollHeight}
							: {height: "0px"}
					}
				>
					<Typography
						content={props.AccordionItem.answer}
						itemProp={"text"}
						size={Size.XS}
						variant={Variant.Description}
					/>
					<Separator size={16} />
				</div>
			</div>
		</div>
	)
}

export default AccordionItem
